<template>
  <a-layout class='index animated fadeIn'>
    <div class="s_bf s_ptb0lr24">
      <a-tabs >
        <a-tab-pane key="1" tab="订单类型统计">
          <orderType></orderType>
        </a-tab-pane>
        <a-tab-pane key="2" tab="区域统计" force-render>
          <regionStatistics></regionStatistics>
        </a-tab-pane>
      </a-tabs>
    </div>
  </a-layout>
</template>
<script>
  import { reactive, toRefs } from "vue";
  import orderType from './components/order_type';
  import regionStatistics from './components/region_statistics';
  export default {
    components: { orderType, regionStatistics },
    setup(props) {
      const state = reactive({

      });
      return {
        ...toRefs(state)
      };
    },
  };
</script>